import React from 'react'
import "./HeaderContent.css"
import homeImg from "../../Assets/IMG-2.jpg"
import homeImg2 from "../../Assets/Home-img2.jpg"
import HeaderLinks from './HeaderLinks'
import { Link as LinkS } from 'react-scroll'
const HeaderContent = () => {
  return (
    <div className="Home-Container"
      data-aos="zoom-in"
      data-aos-easing="linear"
      data-aos-duration="800"
      data-aos-offset="0"
    >
      <div className="homeContent">
        <div className='left-container'>
          <div className='testE'>
            <div className='home-img'>
              <span className='home-imgS'>
                <img className='z-5' src={homeImg2} alt="" /> <img src={homeImg} alt="" />
              </span>
            </div>
          </div>
          <HeaderLinks />
        </div>
        <div className='home-contnet'>
          <h2 className='home-title'>Bringing Your Ideas To <span>~ Life</span></h2>
          <br />
          <h4 className='home-qute'>Elevating your online presence through innovative and dynamic front-end solutions, while crafting seamless and captivating digital experiences that truly engage your audience</h4>
          <div className='home-btns'>
            <div className='home-btn'>
              <span> <a className='btn' href="https://mohammed-metwally-classic.web.app/resume" target="_blank" rel='noreferrer'>Download CV</a></span>
            </div>
            <div className='home-btn'>
              <span> <LinkS to="contact" className='btn btn-primary' smooth={true} duration={2000}>Contact</LinkS></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeaderContent